import React from "react";
import { Col, Container, Row, Image } from "react-bootstrap";

export const RecentWork = () => {
  return (
    <Container fluid className="recent-work-section">
      <Container>
        <Row data-aos="fade-right">
          <Col sm="12" md="12" lg="6">
            <h2>My Recent Work</h2>
          </Col>
          <Col sm="12" md="12" lg="6">
            <p>
              Ullam dicta dolorem quas. Soluta consequatur sed non reiciendis.
              Quia libero voluptatem eveniet.
            </p>
          </Col>
        </Row>
        <Row data-aos="fade-in">
          <Col sm="12" md="12" lg="3">
            <figure>
              <Image
                fluid
                src="https://via.placeholder.com/500x500"
                alt="Placeholder image"
              ></Image>
              <figcaption>Description</figcaption>
            </figure>
          </Col>
          <Col sm="12" md="12" lg="3">
            <figure>
              <Image
                fluid
                src="https://via.placeholder.com/500x500"
                alt="Placeholder image"
              ></Image>
              <figcaption>Description</figcaption>
            </figure>
          </Col>
          <Col sm="12" md="12" lg="3">
            <figure>
              <Image
                fluid
                src="https://via.placeholder.com/500x500"
                alt="Placeholder image"
              ></Image>
              <figcaption>Description</figcaption>
            </figure>
          </Col>
          <Col sm="12" md="12" lg="3">
            <figure>
              <Image
                fluid
                src="https://via.placeholder.com/500x500"
                alt="Placeholder image"
              ></Image>
              <figcaption>Description</figcaption>
            </figure>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
